import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ActionIcon, TextInput } from '@mantine/core';
import { IconCornerDownLeft, IconGripVertical, IconX } from '@tabler/icons-react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './ChecklistFormItem.module.scss';
import { Props } from './ChecklistFormItem.props';

const ChecklistFormItem = ({
  item,
  isLastItem,
  form,
  itemIndex,
  onKeyDown,
  inputRef,
  onDelete,
}: Props) => {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: item.localId,
  });

  return (
    <div
      ref={setNodeRef}
      className={classNames(styles.optionRow, {
        [styles.dragging]: isDragging,
      })}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 10 : 0,
      }}
    >
      <div ref={setActivatorNodeRef} {...attributes} {...listeners} className={styles.dragHandle}>
        <IconGripVertical size={18} stroke={1.5} />
      </div>

      <TextInput
        variant="unstyled"
        {...form.getInputProps(`items.${itemIndex}.label`)}
        className={styles.textInput}
        placeholder={`${t('checklist.form.itemLabel', 'Option')} ${itemIndex + 1}`}
        onKeyDown={onKeyDown}
        ref={inputRef}
      />
      <div className={styles.iconContainer}>
        {isLastItem && (
          <div className={styles.enterIcon}>
            <IconCornerDownLeft height={16} color={'#022C314D'} />
          </div>
        )}
        <ActionIcon
          variant="transparent"
          className={styles.iconButton}
          onClick={onDelete}
          disabled={form.values.items.length < 2}
        >
          <IconX className={styles.icon} height={20} color={'#73999D'} />
        </ActionIcon>
      </div>
    </div>
  );
};

export default ChecklistFormItem;
